import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import { LoadingScreen } from 'src/components/loading-screen';
// auth
import { AuthGuard } from 'src/auth/guard';

const ContributorListViewStore = lazy( () =>
       import( 'src/pages/contributor/view/contributorList/contributorListView' ).then( ( module ) => ( {
              default: module.ContributorListViewStore,
       } ) )
);





const TraineeListViewStore = lazy( () =>
       import( 'src/pages/trainee/view/traineeList/traineeListView' ).then( ( module ) => ( {
              default: module.TraineeListViewStore,
       } ) )
);

const TraineeListView = lazy( () =>
       import( 'src/pages/trainee//view/traineeCreateView/traineeCreateView' )
);

const TraineeProfileView = lazy( () =>
       import( 'src/pages/trainee/view/traineeProfile/traineeProfileView' )
);

const TraineeCreateView = lazy( () =>
       import( 'src/pages/trainee//view/traineeCreateView/traineeCreateView' )
);

const ContributorListView = lazy( () =>
       import( 'src/pages/contributor/view/contributorList/contributorListView' )
);

const ProfileContributorView = lazy( () =>
       import( 'src/pages/contributor/view/contributorProfile/contributorProfileView' )
);

const ContributorCreateView = lazy( () =>
       import( 'src/pages/contributor/view/contributorCreateView/contributorCreateView' )
);

const OrganisationProfileView = lazy( () =>
       import( 'src/pages/organisations/view/organisationProfile/organisationProfileView' )
);

// ----------------------------------------------------------------------

const DashboardLayoutStore = lazy( () =>
       import( 'src/layouts/dashboard/layout' ).then( ( module ) => ( {
              default: module.DashboardLayoutStore,
       } ) )
);

const FormList = lazy( () => import( 'src/pages/form/FormList' ) );

// ----------------------------------------------------------------------

export const traineeOrganizationRoutes = [
       {
              path: 'organization/trainees',
              element: (
                     <AuthGuard allowedRoles={['organization', 'manager']}>
                     <DashboardLayoutStore>
                            <Suspense fallback={ <LoadingScreen /> }>
                                   <Outlet />
                            </Suspense>
                     </DashboardLayoutStore>
                     </AuthGuard>
              ),
              children: [ { element: <TraineeListViewStore />, index: true } ],
       },
];

export const traineeParticipantRoutes = [
       {
              path: 'organization/profile',
              element: (
                     <AuthGuard allowedRoles={['organization', 'manager']}>
                     <DashboardLayoutStore>
                            <Suspense fallback={ <LoadingScreen /> }>
                                   <Outlet />
                            </Suspense>
                     </DashboardLayoutStore>
                     </AuthGuard>
              ),
              children: [ { element: <OrganisationProfileView />, index: true } ],
       },
       {
              path: 'organization/trainees',
              element: (
                     <AuthGuard allowedRoles={['organization', 'trainee', 'manager']}>
                     <DashboardLayoutStore>
                            <Suspense fallback={ <LoadingScreen /> }>
                                   <Outlet />
                            </Suspense>
                     </DashboardLayoutStore>
                     </AuthGuard>
              ),
              children: [
                     { element: <TraineeListViewStore />, index: true },
                     { path: 'addTrainee', element: <TraineeCreateView /> },
                     { path: 'profile', element: <TraineeProfileView key={window.location.pathname + Date.now()} /> },
              ],
       },

       {
              path: 'organization/contributor',
              element: (
                     <AuthGuard allowedRoles={['organization', 'manager']}>
                     <DashboardLayoutStore>
                            <Suspense fallback={ <LoadingScreen /> }>
                                   <Outlet />
                            </Suspense>
                     </DashboardLayoutStore>
                     </AuthGuard>
              ),
              children: [
                     { element: <ContributorListViewStore />, index: true },
                     { path: 'addContibutor', element: <ContributorCreateView /> },
                     { path: 'profile', element: <ProfileContributorView /> },
              ],
       },


       // {
       //        path: 'organization/registration-requests',
       //        element: (
       //               <DashboardLayoutStore>
       //                      <Suspense fallback={ <LoadingScreen /> }>
       //                             <Outlet />
       //                      </Suspense>
       //               </DashboardLayoutStore>
       //        ),
       //        children: [
       //               { element: <TrainingRequestListViewStore />, index: true },
       //               { path: 'reservationList', element: <TrainingFormationReservationListViewStore /> },
       //               // { path: 'profile', element: <ProfileContributorView /> },
       //        ],
       // },
];
